import PopupBasic from 'src/game/components/popups/PopupBasic';
import View from '@play-co/timestep-core/lib/ui/View';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver from 'src/StateObserver';
import { duration } from 'src/replicant/utils/duration';
import { animate } from '@play-co/timestep-core/ui';

import { AssetGroup } from '@play-co/timestep-core';

const seconds = 5;
const adDuration = duration({ seconds });

// This is only for dev purposes
export default class PopupAd extends PopupBasic {
  private showTime: number = 0;

  constructor(opts: { superview: View; close: (result: boolean) => void }) {
    super({
      ...opts,
      close: () => opts.close(StateObserver.now() - this.showTime > adDuration),
      zIndex: 10010,
      width: 556,
      height: 455,
      tracking: { feature: 'popup-ad', $subFeature: 'popup-ad' },
      skipTitle: true,
    });

    this.bg.updateOpts({
      backgroundColor: '#000000',
    });
    this.bg.addSubview(this.buttonClose);
    this.bg.addSubview(this.message);
    this.message.updateOpts({
      x: 50,
      y: 100,
      width: 470,
      height: 200,
      zIndex: 1,
      size: 40,
      color: '#FFFFFF',
      font: 'Body',
      visible: true,
      align: 'left',
    });
    this.buttonClose.updateOpts({
      x: 50,
      y: 50,
    });

    const loadingBar = new View({
      superview: this.bg,
      width: 470,
      height: 20,
      backgroundColor: '#FFFFFF',
      x: 50,
      y: 300,
    });

    const readyText = new LangBitmapFontTextView({
      superview: this.bg,
      x: 50,
      y: 300,
      width: 470,
      height: 50,
      size: 40,
      color: '#FFFFFF',
      font: 'Body',
      localeText: () => 'Ready',
      visible: false,
    });

    animate(loadingBar)
      .then({ width: 0 }, adDuration, animate.linear)
      .then(() => readyText.show());

    this.box.removeFromSuperview();
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init() {
    super.init({});

    this.showTime = StateObserver.now();
    this.message.localeText = () =>
      `Close after ${seconds} seconds\nto recieve a reward`;
  }
}
